import React, { useMemo } from 'react';
import { useBoolean } from 'ahooks';
import IconDom from '@intelligence/components/SelectCompoenet/ItemDom/IconDom';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { IMetricsOptionItem } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/MetricsSelection/config';

import './index.scss';

interface ItemType {
  value: string;
  [key: string]: any;
}

interface IMetricBoxProps {
  options: IMetricsOptionItem[];
  metricsValue: string[];
  onChange: (value: string[]) => void;
  dateGranularityType?: 'daily' | 'weekly' | 'monthly';
}

const needProcessMetricsValue = [
  'ampere_d1',
  'ampere_d7',
  'ampere_d14',
  'ampere_d28',
  'ampere_d60',
  'ampere_rolling_d1',
  'ampere_rolling_d7',
  'ampere_rolling_d14',
  'ampere_rolling_d28',
  'ampere_rolling_d60',
];

const MetricBox = (props: IMetricBoxProps) => {
  const { options, metricsValue = [], dateGranularityType, onChange } = props;
  const isMonthly = dateGranularityType === 'monthly';
  const middle = isMonthly ? 'monthly_' : '';
  const splitor = 'dbi_metric_';

  const { formatMessage } = useIntlExtend();

  const [showMore, { toggle }] = useBoolean(false);

  const handleItemClick = (item: ItemType) => {
    const val = item?.value;
    const arr = [...metricsValue];
    if (arr.includes(val)) {
      // 元素存在，找到元素索引并删除
      const index = arr.indexOf(val);
      arr.splice(index, 1);
    } else {
      // 元素不存在，添加到数组
      // arr.push(val);
      // 新选中的放在前面
      arr.unshift(val);
    }

    onChange(arr);
  };

  // console.debug('MetricBox', { props, metricsValue, options, dateGranularityType });

  const defaultList = useMemo(() => {
    const dataObject: any = {};
    options?.forEach((element) => {
      const objKey = element?.metricBoxGroup || element?.dataSource;
      if (dataObject[objKey]) {
        dataObject[objKey].push(element);
      } else {
        dataObject[objKey] = [element];
      }
    });
    const metricsList = Object.values(dataObject);
    return metricsList?.map((item: any) => {
      const e = item[0];
      return (
        <div className="dbi_metric_box" key={e.metricBoxGroup || e.dataSource}>
          <div className="dbi_metric_box_icon">
            {e?.hideMetricBoxIcon || e?.dataSource === 'opinions' ? (
              <div className="dbi_none_icon_div"></div>
            ) : (
              <IconDom
                data={{
                  img: getDataSourceIcon(e?.icon ? e?.icon : e?.dataSource || e?.value),
                }}
              />
            )}
          </div>
          <div className="dbi_metric_box_inner">
            {item.map((ele: any, index: number) => {
              if (!showMore && e.dataSource === 'newzoo' && index > 2) {
                return null;
              }
              const textStrArr = ele?.text?.split(splitor);
              const rawMetricText = textStrArr?.[textStrArr?.length - 1];
              return (
                <div
                  onClick={() => handleItemClick(ele)}
                  className={`dbi_metric_box_item ${
                    metricsValue.includes(ele.value) ? 'dbi_metric_box_item_active' : ''
                  }`}
                  key={ele.value}
                >
                  {/* {formatMessage({ id: ele.text })} */}
                  {isMonthly && needProcessMetricsValue.includes(ele?.value)
                    ? formatMessage({ id: `${splitor}${middle}${rawMetricText}` })
                    : formatMessage({ id: ele?.text })}
                </div>
              );
            })}
            {e.dataSource === 'newzoo' ? (
              <div className="dbi_metric_box_button" onClick={toggle}>
                {formatMessage({
                  id: showMore ? 'dbi_top_hide_more' : 'dbi_top_show_more',
                })}
              </div>
            ) : null}
          </div>
        </div>
      );
    });
  }, [options, metricsValue, showMore]);

  const optionsValues = useMemo(() => {
    return options?.map((item: any) => item.value);
  }, [options]);

  const metricsValueBox = useMemo(() => {
    return metricsValue?.filter((item: any) => optionsValues?.includes(item));
  }, [metricsValue, optionsValues]);

  const handleClearAll = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
    const boxList = [...optionsValues];
    const valueList = [...metricsValue];
    if (metricsValueBox.length) {
      const valueTemp = valueList?.filter((item) => !boxList?.includes(item));
      onChange(valueTemp);
      return;
    }
    const valueAllTemp = [...valueList, ...boxList];
    onChange(valueAllTemp);
  };

  return (
    <div>
      <div className="dbi_metric_box_clear_all" onClick={handleClearAll}>
        <span>
          {metricsValueBox?.length
            ? formatMessage({ id: 'dbi_clear_all' })
            : formatMessage({ id: 'dbi_select_all' })}
        </span>
      </div>
      <div>{defaultList}</div>
    </div>
  );
};
export default MetricBox;
